import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_8: FaireProductEntity = {
  token: "atc_toast_8",
  type: "product",
  name: "Ceramic Match Striker",
  brandName: "Skeem Design",
  imageUrl: "",
  priceDollars: 15.0,
  msrpDollars: 30.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
